<!--
 * @Description: 商品批次流通追溯详情-全流程追溯
 * @Author: WuPuyi
 * @LastEditors: WuPuyi
 * @Date: 2020-12-02 09:59:23
 * @LastEditTime: 2020-12-11 15:58:30
-->
<template>
  <div
    class="whole-process-trace"
    v-loading="loading"
    element-loading-text="拼命加载中"
  >
    <e6-title>商品批次流通追溯详情</e6-title>
    <section class="whole-process-trace-container">
      <div class="whole-process-trace-content">
        <div class="main">
          <div class="item goods-info">
            <div class="item-title">
              <h2 class="item-title--content">商品信息</h2>
              <span class="item-title--btn">
                <el-button type="text" @click="handleGoToBatchFlow"
                  >查看批次流通信息</el-button
                >
              </span>
            </div>
            <div class="item-content">
              <el-form label-width="200px">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="追溯码">
                      {{ goodsDetail.tagCode }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="商品名称">
                      {{ goodsDetail.productName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="生产厂商">
                      {{ goodsDetail.manufacturer }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="所属商户">
                      {{ goodsDetail.companyName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="商户联系方式">
                      {{ goodsDetail.companyTel }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="厂商地址">
                      {{ goodsDetail.productionAddress }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" v-if="goodsDetail.isImport === 1">
                    <el-form-item label="原产地">
                      {{ goodsDetail.countryName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" v-if="goodsDetail.isImport === 1">
                    <el-form-item label="入境口岸">
                      {{ goodsDetail.portName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" v-if="goodsDetail.isImport === 1">
                    <el-form-item label="入境日期">
                      {{ goodsDetail.entryDate }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
          <div class="item whole-process-trace-item">
            <div class="item-title">
              <h2 class="item-title--content">全流程追溯</h2>
            </div>
            <div class="item-content">
              <e6-time-line
                class="time-line"
                :data="wholeData"
                :nodeWidth="352"
                :nodeHeight="250"
                :axisHeight="30"
              >
                <div class="top" slot="top" slot-scope="{ node }">
                  <div class="content">
                    <i
                      :style="{ color: node.dotColor }"
                      :class="formatNodeIcon(node.nodeType)"
                      @click="
                        handleGoToTraceDetail(node.stage, node.warehouseId)
                      "
                    ></i>
                    <span>{{ node.nodeName }}</span>
                  </div>
                </div>
                <div class="bottom" slot="bottom" slot-scope="{ node }">
                  <template v-if="node.nodeType !== 3">
                    <div class="type-name">{{ node.companyName }}</div>
                    <div>
                      平均温{{ node.temperatureAvg }}℃，最高温{{
                        node.temperatureMax
                      }}℃，最低温{{ node.temperatureMin }}℃
                    </div>
                    <div>开始时间：{{ node.startTime }}</div>
                    <div>结束时间：{{ node.endTime }}</div>
                  </template>
                  <template v-else>
                    <div class="type-name">{{ node.nodeName }}</div>
                    <div>
                      收货人：{{ node.receiverName }} {{ node.receiverTel }}
                    </div>
                    <div>结束时间：{{ node.endTime }}</div>
                  </template>
                </div>
              </e6-time-line>
            </div>
          </div>
        </div>
      </div>
      <div class="whole-process-trace-footer">
        <el-button class="goback-btn" @click="handleGoBack">返回</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import {
  fetchGoodsByTagCode,
  fetchWholeTrace
} from "@/api/goodsTrace/goodsTrace.js";
import { cloneDeep } from "lodash";

const STORAGE_COLOR = "#3095fd"; // 仓
const VEHICLE_COLOR = "#67c23a"; // 车
const GOODS_COLOR = "#9255de"; // 货

export default {
  data() {
    return {
      loading: false,
      goodsDetail: {
        tagCode: "", // 追溯码
        productName: "", // 商品名称
        manufacturer: "", // 生产厂商
        companyName: "", // 所属商户
        companyTel: "", // 商户联系方式
        productionAddress: "", // 厂商地址
        isImport: "", // 是否进口 1-是 0-否
        countryName: "", // 原产国/地
        portName: "", // 口岸名称（入境口岸）
        entryDate: "" // 入境日期
      },
      wholeData: []
    };
  },
  created() {
    let { tagCode } = this.$route.query;
    this.init(tagCode);
  },
  methods: {
    // 初始化数据
    async init(tagCode) {
      try {
        this.loading = true;
        // 商品详情
        let goodsRes = await fetchGoodsByTagCode({ tagCode });
        if (goodsRes.code === 1 && goodsRes.result) {
          this.goodsDetail = cloneDeep(goodsRes.result);

          // 全流程追溯信息
          let wholeRes = await fetchWholeTrace({
            codeId: goodsRes.result.codeId,
            tagCode: tagCode
          });

          if (wholeRes.code === 1 && Array.isArray(wholeRes.result)) {
            this.handleWholeData(wholeRes.result);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // 处理全流程信息的数据
    handleWholeData(data) {
      let result = [];
      data.forEach((item, index) => {
        let lineColor = "";
        let dotColor = "";
        // 仓库
        if (item.nodeType === 1) {
          lineColor = STORAGE_COLOR;
          dotColor = STORAGE_COLOR;
        }
        // 车辆
        if (item.nodeType === 2) {
          lineColor = VEHICLE_COLOR;
          dotColor = VEHICLE_COLOR;
        }
        // 收货
        if (item.nodeType === 3) {
          lineColor = "#ffffff";
          dotColor = GOODS_COLOR;
        }
        result.push({
          companyName: item.companyName, // 企业名称
          corpId: item.corpId, // 企业id
          startTime: item.startTime, // 开始时间
          endTime: item.endTime, // 结束时间
          stage: item.stage, // 阶段数
          nodeType: item.nodeType, // 类型 0-仓库,1-车辆,2-收货
          nodeId: item.nodeId,
          nodeName: item.nodeName, // 名称
          receiverName: item.receiverName, // 联系人
          temperatureAvg: item.temperatureAvg, // 平均温度
          temperatureMax: item.temperatureMax, // 最高温度
          temperatureMin: item.temperatureMin, // 最低温度
          receiverTel: item.receiverTel, // 联系电话
          warehouseId: item.warehouseId,
          lineColor: lineColor,
          dotColor: dotColor
        });
      });

      this.wholeData = cloneDeep(result);
    },
    // 生成S型轴线图的icon图表
    formatNodeIcon(type) {
      let className = "";
      switch (type) {
        case 1:
          className = "e6-icon-warehouse_fill";
          break;
        case 2:
          className = "e6-icon-truck_fill";
          break;
        case 3:
          className = "e6-icon-goods_fill";
          break;
      }
      return className;
    },
    handleGoToTraceDetail(stage, warehouseId) {
      let { tagCode } = this.$route.query;
      console.log(warehouseId);
      this.$router.push({
        path: "/goodsTraceGoodsTraceDetail",
        query: {
          tagCode,
          stage,
          warehouseId
        }
      });
    },
    handleGoToBatchFlow() {
      let { tagCode } = this.$route.query;
      this.$router.push({
        path: "/goodsTraceGoodsBatchTrace",
        query: {
          tagCode
        }
      });
    },
    // 返回
    handleGoBack() {
      this.$router.push("/goodsTraceSearch");
    }
  }
};
</script>

<style lang="scss" scoped>
.whole-process-trace {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-color: #edf1f6;
}
.whole-process-trace-container {
  position: relative;
  width: 100%;
  height: calc(100% - 39px);
  background-color: #ffffff;
  margin-top: 10px;
  border-radius: 4px;
  box-shadow: 0px 0px 8px 0px rgba(62, 67, 244, 0.1);
}
.whole-process-trace-content {
  width: 100%;
  height: calc(100% - 56px);
  overflow-y: auto;
  .main {
    width: 100%;
    .item {
      width: 100%;
      .item-title {
        box-sizing: border-box;
        width: 100%;
        height: 42px;
        line-height: 42px;
        padding: 0 20px;
        background: #fafbfc;
        border: 1px solid #edf0f5;
        display: flex;
        justify-content: space-between;
        &--content {
          margin: 0;
          font-size: 14px;
          line-height: 42px;
          font-weight: bold;
          color: #303133;
        }
      }
    }
  }
  .goods-info {
    .item-content {
      padding-top: 20px;
      /deep/.el-form {
        .el-form-item__label {
          font-size: 14px;
          color: #849bbd;
        }
        .el-form-item__content {
          font-size: 14px;
          color: #606266;
        }
      }
    }
  }
  .whole-process-trace-item {
    .item-content {
    }
    .time-line {
      color: #606266;
      .top {
        position: relative;
        height: 100%;
        .content {
          position: absolute;
          bottom: 0;
          left: 0px;
          height: 40px;
          width: 100%;
          display: flex;
          align-items: center;
          & > i {
            font-size: 35px;
            cursor: pointer;
          }
          & > span {
            font-size: 16px;
            margin-left: 12px;
          }
        }
      }
      .bottom {
        font-size: 12px;
        line-height: 20px;
        color: #909399;
        .type-name {
          font-size: 14px;
          color: #606266;
          margin-bottom: 5px;
        }
      }
    }
    /deep/ .e6-time-line-item {
      .tiem-node__top,
      .tiem-node__bottom {
        position: relative;
        .top,
        .bottom {
          position: absolute;
          left: -10px;
          right: 30px;
          height: 100%;
        }
      }

      &.odd {
        .tiem-node__top,
        .tiem-node__bottom {
          .top,
          .bottom {
            left: 30px;
            right: -8px;
          }
        }
        .top {
          .content {
            flex-direction: row-reverse;
            i {
              transform: scaleX(-1);
            }
          }
          span {
            margin-right: 12px;
          }
        }
        .bottom {
          text-align: right;
        }
      }
    }
  }
}
// 底部返回
.whole-process-trace-footer {
  width: 100%;
  height: 56px;
  background-color: #fafbfc;
  border: 1px solid #edf0f5;
  box-shadow: 0px -1px 10px 0px rgba(0, 0, 0, 0.07);
  line-height: 56px;
  text-align: center;
  .goback-btn {
    width: 100px;
    height: 36px;
    background: #dae1eb;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #909399;
  }
}
</style>
